import { useMemo } from 'react';

import useContactColumns from 'hooks/queries/useContactColumns';
import useSms from 'hooks/queries/useSms';
import { getMergeTags } from 'utils';

const useSmsData = ({ id, enabled }: { id: string | null; enabled?: boolean }) => {
    const isQueryEnabled = id !== 'default' && id != null && enabled;
    // Fetch SMS and contact data (only when editing an existing SMS)
    const { data: smsData, isSuccess, isLoading, error } = useSms(id, {
        enabled: isQueryEnabled,
    });

    const { data: contactColumns, isSuccess: isContactColumnsSuccess } = useContactColumns();

    // Derived state
    const isSavedSmsContent = useMemo(() => isSuccess && !!smsData?.id, [isSuccess, smsData]);

    const mergeTags = useMemo(() => {
        if (isContactColumnsSuccess) {
            return getMergeTags(contactColumns);
        }
        return [];
    }, [contactColumns, isContactColumnsSuccess]);

    const orderedMergeTags = useMemo(() => mergeTags?.sort((a, b) => a.value.localeCompare(b.value)), [mergeTags]);

    // When we're not fetching (create/new SMS), don't report loading so the save button tooltip doesn't show "Content is loading"
    const isLoadingState = isQueryEnabled ? isLoading : false;

    return {
        error,
        mergeTags: orderedMergeTags,
        smsData,
        isLoading: isLoadingState,
        isSavedSmsContent,
    };
};

export default useSmsData;
